import { Component, OnInit } from '@angular/core';
import { DashboardService } from '../../rm/dashboard/dashboard.service';
import { Observable } from 'rxjs/Observable';
import { PlannedActualService } from './planned-actual.service';
import { ActivatedRoute } from '@angular/router';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';

@Component({
  selector: 'app-planed-actual',
  templateUrl: './planed-actual.component.html',
  styleUrls: ['./planed-actual.component.css']
})
export class PlanedActualComponent implements OnInit {
  public employeelistarr: any = [];
  public filteredOptions: Observable<string[]>;
  public selectedempno: any;
  public projectList: any = [];
  public showTable = false;
  public planned: any;
  public value: any = [];
  public total = 0;
  public empName: string;
  constructor(
    private dashboardService: DashboardService,
    private plannedActualService: PlannedActualService,
    public activatedRoute: ActivatedRoute,
    private spinnerService: Ng4LoadingSpinnerService) { }

  ngOnInit() {
    this.getrmEmployeeLists();
  }

  //function to get employee list
  getrmEmployeeLists() {
    this.employeelistarr = [];
    this.spinnerService.show();
    this.dashboardService.getDashboardEmployeeList().subscribe((data) => {
      this.spinnerService.hide();
      if (data.payload.employeeCount) {
        data.payload.employeeCount.empList.forEach(value => {
          this.employeelistarr.push(value);
        });
      }
    }, (error) => {
      this.spinnerService.hide();
    });
  }

  //function to filter employee list
  filterEntities(event: any) {
    const searchItem = event.target.value;
    if (event.target.value !== 'undefined') {
      this.filteredOptions = this.employeelistarr.filter(s => s.Empname.toLowerCase().indexOf(searchItem.toLowerCase()) == 0);
    }
    if (searchItem == '') {
      this.getrmEmployeeLists();
    }
  }

  //function to get detail of employee selected
  employeeSelected(option) {
    this.projectList = [];
    this.showTable = true;
    this.selectedempno = option.Empno;
    this.plannedActualService.getPlanedDetail(this.selectedempno).subscribe(
      (data) => {
        if (data.payload.AssignedProject) {
          data.payload.AssignedProject.forEach(value => {
            this.projectList.push(value);
            this.total += value.totalHrs;
            this.value.push[0];
          });
        }
      });
  }

  //function to calculate hours
  calculate(data, event, i) {
    if (event.target.value != 0) {
      this.value[i] = ((data.totalHrs - event.target.value) / (data.totalHrs) * 100).toFixed(2);
    } else {
      this.value[i] = 0;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/admin/planed-actual/planed-actual.component.ts